import React, { useState, useEffect } from "react";
import axios from "axios";
import Farm from "../../../assets/images/farm2.png";

import './styles.css';

const CardRural = () => {

    const apiUrl = process.env.REACT_APP_API_URL;
    const apiImg = process.env.REACT_APP_API_IMG;

    const [randomRural, setRandomRural] = useState(null);

    useEffect(() => {
        fetchRandomRural();
    }, []);

    const fetchRandomRural = async () => {
        try {
            const response = await axios.get(`${apiUrl}/random_rural`);
            setRandomRural(response.data);
        } catch (error) {
            console.error("Erro ao buscar o rural aleatório:", error);
        }
    };

    return (
        <>
            <div className="container rural">

                <div className="row">
                    {randomRural && (
                        <>
                            <div className="title-rural">
                                <div className="title-rural-img">
                                    <h1>{randomRural.title}</h1>
                                    {/* <h1><img src={Farm} alt="call center" /> {randomRural.title}</h1> */}
                                </div>
                                <div className="sub">
                                    <h3>{randomRural.sub}</h3>
                                </div>
                            </div>
                            <div className="assinar w-full">
                                <img
                                    src={`${apiImg}/assets/rurais/${randomRural.foto}`}
                                    alt="Gigabyte Internet Rural 4G LTE"
                                    className="w-full h-auto block"
                                />

                                <div className="buttons">
                                    <a href="/internet-rural" className="btn-hover color-6">Escolha seu plano!</a>
                                    {/* <button >Contratar agora!</button> */}
                                </div>

                            </div>
                            <div className="text" dangerouslySetInnerHTML={{ __html: randomRural.text }} />
                        </>
                    )}
                    {/* {randomRural && Object.keys(randomRural).length > 0 &&
                        <span> * Valor promocional válido somente para pagamentos até a data do vencimento. </span>
                    } */}
                </div>
                <br />
                <br />
            </div>
        </>
    );
}

export default CardRural;
